import * as ResponseNS from '../ServerSideRendering/Response.js';
import * as ServerContextNS from '../ServerSideRendering/ServerContext.js';
import * as DefaultAccessorNS from '../ServerSideRendering/IServerContextAccessor.js';
import * as BrowserAccessorNS from '../ServerSideRendering/BrowserServerContextAccessor.js';
import * as DotNetAccessorNS from '../ServerSideRendering/DotNetServerContextAccessor.js';

export import Response = ResponseNS.Response;
export import Context  = ServerContextNS.ServerContext;
export import IAccessor = DefaultAccessorNS.IServerContextAccessor;
export import IStaticAccessor = DefaultAccessorNS.IStaticServerContextAccessor;
export import Factory = DefaultAccessorNS.Factory;

export import Accessor = BrowserAccessorNS.BrowserServerContextAccessor;
export import BrowserAccessor = BrowserAccessorNS.BrowserServerContextAccessor;
export import DotNetAccessor = DotNetAccessorNS.DotNetServerContextAccessor;
